import { useRouter } from "next/router";
import { FC, useEffect } from "react";

import { storeRakutenSiteID } from "./helpers";

export const RakutenService: FC<{}> = () => {
    const { asPath } = useRouter();

    useEffect(() => {
        const { ranSiteID } = Object.fromEntries(
            new URLSearchParams(asPath.split("?")[1])
        );

        if (ranSiteID) {
            storeRakutenSiteID(ranSiteID);
        }
    }, [asPath]);

    return null;
};
